import { render, staticRenderFns } from "./UpgradeScoreLineManage.vue?vue&type=template&id=2d592add&scoped=true"
import script from "./UpgradeScoreLineManage.vue?vue&type=script&lang=js"
export * from "./UpgradeScoreLineManage.vue?vue&type=script&lang=js"
import style0 from "./UpgradeScoreLineManage.vue?vue&type=style&index=0&id=2d592add&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d592add",
  null
  
)

export default component.exports